<template>
    <div>
        <b-overlay :show="show" rounded="sm">
            <template v-if="notificationType.length > 0">
                <b-table :items="notificationType" responsive :fields="fields" class="mb-0" id="theme-table">
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(action)="data" v-if="manage">
                        <div class="d-flex align-items-center">
                            <b-dropdown variant="link" no-caret>
                                <template #button-content>
                                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                                </template>
                                <b-dropdown-item @click="editNotificationTypeData(data.item)">
                                    <div>
                                        <feather-icon icon="EditIcon" />
                                        <span class="align-middle ml-50">Edit</span>
                                    </div>
                                </b-dropdown-item>
                                <b-dropdown-item @click="deleteNotificationType(data.item._id, data.item.name)">
                                    <div>
                                        <b-spinner v-if="loading" small class="mr-1" />
                                        <feather-icon v-else icon="TrashIcon" />
                                        <span class="align-middle ml-50">Delete</span>
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </template>
                </b-table>
            </template>
            <template v-else>
                <div class="text-center mb-2">No records found</div>
            </template>
        </b-overlay>
        <EditNotificationType :token="token" :notificationData="notificationTypeData" @fetchTypes="fetchTypes"
            @removeNotificationData="removeNotificationData" />
    </div>
</template>

<script>
import {
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BFormGroup,
    BSpinner,
} from "bootstrap-vue";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
        EditNotificationType: () => import("./EditNotificationType.vue"),
        BButton,
        BFormInput,
        BFormGroup,
        BTable,
        BDropdown,
        BDropdownItem,
        BOverlay,
        BSpinner,
        ToastificationContent,
    },
    data() {
        return {
            fields: [
                "index",
                { key: "name", label: "Notification Type Name" },
                { key: "description", label: "Notification Type description" },
                { key: "action", label: "ACTION" },
            ],
            loading: false,
            notificationTypeData: {},
            alertMessageToast: "",
        };
    },
    methods: {
        showToast(variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: "Notification",
                    icon: "BellIcon",
                    text: this.alertMessageToast,
                    variant,
                },
            });
        },
        removeNotificationData() {
            this.notificationTypeData = "";
        },
        fetchTypes() {
            this.$emit('fetchNotificationTypes');
        },
        editNotificationTypeData(notificationtype) {
            this.notificationTypeData = notificationtype;
            this.$bvModal.show("update-notification-type-modal");
        },
        deleteNotificationType(id, name) {
            Swal.fire({
                title: "Are you sure?",
                text: `Do You want to delete ${name} notification type!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.delete(id)
                }
            });
        },
        async delete(id) {
            this.loading = true;
            try {
                const resp = await axios.delete(`${process.env.VUE_APP_API_URL}/notification-type/${id}`, {
                    headers: {
                        Authorization: this.token,
                    },
                });

                if (resp.data.status === 200) {
                    this.alertMessageToast = resp.data.message;
                    this.showToast("success");
                    this.loading = false;
                    this.$emit('fetchNotificationTypes');
                }
            } catch (error) {
                if (error.response) {
                    this.errorMsg = error.response.data.error || 'An error occurred';
                } else if (error.request) {
                    this.errorMsg = 'No response received from server. Please check your network connection.';
                } else {
                    this.errorMsg = 'Error in setting up the s: ' + error.message;
                }
                this.alertMessageToast = resp.data.message;
                this.showToast("danger");
                this.loading = false;
            }
        },
    },
    props: ["show", "notificationType", "manage", "token"],
};
</script>
<style>
#theme-table th:first-child {
    width: 100px;
}

#theme-table th:last-child {
    width: 100px;
}

#theme-table td {
    word-break: break-all;
}
</style>
